import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { Observable } from 'rxjs';
import { API_URL } from '../../constant/url.constant';
import { AppConstants } from '../../constant/app.constant';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(private http: HttpClient) {}
  private reloadNavbarSubject = new BehaviorSubject<boolean>(false);

  // Observable to listen for reload events
  reloadNavbar$ = this.reloadNavbarSubject.asObservable();

  // Trigger reload
  triggerReload() {
    this.reloadNavbarSubject.next(true);
  }

  userProfile(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.User.list}`,
      data
    );
  }
  private profileData = new BehaviorSubject<any>(null); // Holds the shared data
  profileData$ = this.profileData.asObservable(); // Observable for other components to subscribe to

  // Set the shared data
  profileDataData(data: any) {
    this.profileData.next(data);
  }
  private dataSubject = new BehaviorSubject<any>(null); // Holds the shared data
  data$ = this.dataSubject.asObservable(); // Observable for other components to subscribe to

  // Set the shared data
  setData(data: any) {
    this.dataSubject.next(data);
  }

  uploadFile(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.User.uploadFile}`,
      data
    );
  }

  updateProfile(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.User.updateProfile}`,
      data
    );
  }
  OrderList(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.Order.list}`,
      data
    );
  }
  OrderItemList(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.Order.itemlist}`,
      data
    );
  }
  returnReplaceOrderItemList(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.Order.returnReplaceitemlist}`,
      data
    );
  }
  OrderDetail(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.Order.detail}`,
      data
    );
  }
  OrderCancel(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.Order.cancelOrder}`,
      data
    );
  }

  buyAgain(data: any): Observable<any> {
    return this.http.post(
      `${API_URL.baseURL}${API_URL.webData.orderProduct.buyAgain}`,
      data
    );
  }
}
